import * as React from 'react';
import { FormControl, Grid, FormControlLabel, Checkbox, TextField } from '@material-ui/core';
import { updateQuestionDataValue } from 'src/effects/utils/preview';
import { ModuleEnum } from 'src/constants/Enum/ModuleEnum';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';

export default class NumericTypeQuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };

        this.onAnswerChange = this.onAnswerChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    setLocalState(props: any) {
        for (let index: number = 1; index <= props.question.class_type; index++) {

            const questionResponse = props.question.question_responses[index - 1];
            const defaultQuestionResponses = props.question.default_question_responses.find((resp: any) => resp.class_type === index);
            const isEditable = props.isResponsePage && props.surveyType === 1 ? true : defaultQuestionResponses && (defaultQuestionResponses.value || (defaultQuestionResponses.value + '').length > 0) ? defaultQuestionResponses.is_Editable : true;

            if ((props.isReviewQuetion || !props.isResponsePage) && !questionResponse.value) {
                questionResponse.value = defaultQuestionResponses && defaultQuestionResponses.value;
            }

            if (this.state[props.pageNumber + '_' + props.questionId + "_" + index] !== questionResponse.value ||
                this.state[props.pageNumber + '_' + props.questionId + "_" + index + "_" + "Unavailable"] !== props.question.question_responses[index - 1].unavailable) {

                this.setState({
                    [props.pageNumber + '_' + props.questionId + "_" + index]: questionResponse.value ? questionResponse.value : '',
                    [props.pageNumber + '_' + props.questionId + "_" + index + "isDisabled"]: props.question.question_responses[index - 1].unavailable || !isEditable,
                    [props.pageNumber + '_' + props.questionId + "_" + index + "_" + "Unavailable"]: props.question.question_responses[index - 1].unavailable
                });
            }
        }
    }

    componentDidMount() {
        this.setLocalState(this.props);
        if (this.props.pageNumber > 0) {
            this.autoCalculateHorizontal(this.props)
            this.autoCalculateVertical(this.props);
        }
    }

    componentWillReceiveProps(nextProps: any) {
        this.setLocalState(nextProps);
        this.autoCalculateHorizontal(nextProps)
        this.autoCalculateVertical(nextProps);
    }

    onAnswerChange(classType: any, event: any) {
        if (event.target.value.toString().indexOf('-') === -1 && event.target.value.toString().indexOf('e') === -1) {
            const inputValue = parseInt(event.target.value, 10);
            if (!isNaN(inputValue)) {
                this.setState({ [event.target.name]: inputValue });
            } else if (event.target.value.length === 0) {
                this.setState({ [event.target.name]: event.target.value });
            }
        }
    }

    handleKeyPress(classType: any, event: any) {
        if (event.charCode !== 8 && event.charCode !== 0 && event.charCode !== 46 && event.charCode < 48 || event.charCode > 57) {
            event.preventDefault();
        }
    }

    onAnswerBlur(classType: any, event: any) {
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, event.target.value, false, null, true, [])
        }
    }

    onUncheckedChange(classType: any, txtName: any, event: any) {
        this.setState({ [event.target.name]: event.target.checked });
        this.setState({ [txtName]: "" });

        if (!event.target.checked) {
            this.setState({ [this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "isDisabled"]: false });
        }
        else {
            this.setState({ [this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "isDisabled"]: true });
        }

        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, '', event.target.checked, null, true, []);
        }
    }

    autoCalculateHorizontal(props: any) {
        const autoCalConfig = props.question.auto_calculation_config;
        if (autoCalConfig && props.question.class_type === 3) {
            if (autoCalConfig.is_horizontal && autoCalConfig.horizontal_config) {
                if (autoCalConfig.horizontal_config.operator) {

                    let calculatedValue: any;
                    const operandOne = parseInt(props.question.question_responses[autoCalConfig.horizontal_config.operand_one_set - 1].value, 10);
                    const operandTwo = parseInt(props.question.question_responses[autoCalConfig.horizontal_config.operand_two_set - 1].value, 10);

                    switch (autoCalConfig.horizontal_config.operator) {
                        case "+":
                            {
                                if (!operandOne && !operandTwo) {
                                    calculatedValue = 0
                                }
                                else if (operandOne && !operandTwo) {
                                    calculatedValue = operandOne;
                                }
                                else if (!operandOne && operandTwo) {
                                    calculatedValue = operandTwo;
                                }
                                else {
                                    calculatedValue = operandOne + operandTwo;
                                }
                            }
                            break;
                        case "-":
                            {
                                if (!operandOne && !operandTwo) {
                                    calculatedValue = 0
                                }
                                else if (operandOne && !operandTwo) {
                                    calculatedValue = operandOne;
                                }
                                else if (!operandOne && operandTwo) {
                                    calculatedValue = 0 - operandTwo;
                                }
                                else {
                                    calculatedValue = operandOne - operandTwo;
                                }
                            }
                            break;
                        case "%":
                            {
                                if (operandOne && operandTwo) {
                                    const unroundedValue = (operandOne / operandTwo) * 100;
                                    if (!Number.isNaN(unroundedValue)) {
                                        const rounded = Math.round(unroundedValue * 10) / 10;
                                        calculatedValue = rounded.toFixed(1);
                                    }
                                    else {
                                        calculatedValue = 0;
                                    }
                                }
                                else {
                                    calculatedValue = 0
                                }
                            }
                            break;
                        case "%of":
                            {
                                if (operandOne && operandTwo) {
                                    const unroundedValue = (operandOne / 100) * operandTwo;
                                    if (!Number.isNaN(unroundedValue)) {
                                        const rounded = Math.round(unroundedValue * 10) / 10;
                                        calculatedValue = rounded.toFixed(1);
                                    }
                                    else {
                                        calculatedValue = 0;
                                    }
                                }
                                else {
                                    calculatedValue = 0
                                }
                            }
                            break;
                    }

                    if (this.props.question.question_responses &&
                        this.props.question.question_responses.length === 3 &&
                        !Number.isNaN(calculatedValue) &&
                        props.question.question_responses[2].value !== calculatedValue) {
                        updateQuestionDataValue(props, 3, calculatedValue.toString(), false, null, true, [])
                    }
                }
            }
        }
    }

    getQuestionByQuestionId(questionId: any) {
        const questionMetadata = {
            clusterIndex: 0,
            questionIndex: 0,
            question: undefined,
            questionId: 0
        }

        const questioClusters = this.props.pagePreview.question_clusters;
        let isAutocalculateFoundAtCurrentPage: boolean = false;
        for (let clusterIndex: any = 0; questioClusters.length > clusterIndex; clusterIndex++) {
            for (let questionIndex: any = 0; questioClusters[clusterIndex].questions.length > questionIndex; questionIndex++) {
                const questionData = questioClusters[clusterIndex].questions[questionIndex];
                if (questionData && questionData.question_id === questionId) {
                    questionMetadata.clusterIndex = clusterIndex;
                    questionMetadata.questionIndex = questionIndex;
                    questionMetadata.questionId = questionId;
                    questionMetadata.question = questionData;
                    isAutocalculateFoundAtCurrentPage = true;
                    return questionMetadata;
                }
            }
        }

        if (!isAutocalculateFoundAtCurrentPage) {
            for (const page of this.props.pages) {
                if (this.props.pagePreview.page_number !== page.page_number) {
                    for (let clusterIndex: any = 0; clusterIndex < page.page.question_clusters.length; clusterIndex++) {
                        for (let questionIndex: any = 0; questionIndex < page.page.question_clusters[clusterIndex].questions.length; questionIndex++) {
                            const questionData = page.page.question_clusters[clusterIndex].questions[questionIndex];
                            if (questionData && questionData.question_id === questionId) {
                                questionMetadata.clusterIndex = clusterIndex;
                                questionMetadata.questionIndex = questionIndex;
                                questionMetadata.questionId = questionId;
                                questionMetadata.question = questionData;
                                return questionMetadata;
                            }
                        }
                    }
                }
            }
        }

        return questionMetadata;
    }

    getQuestionResponses(question: any) {
        if (question) {
            const setOneResponse = question.question_responses[0].value;
            let setTwoResponse;
            let setThreeResponse;

            if (question.class_type === 2) {
                setTwoResponse = question.question_responses[1].value;
            }
            if (question.class_type === 3) {
                setTwoResponse = question.question_responses[1].value;
                setThreeResponse = question.question_responses[2].value;
            }

            const responses = [setOneResponse, setTwoResponse, setThreeResponse];
           
            return responses;

        }
        return;
    }

    getQuestionResponsesById(questionId: any) {
        const questionMetadata = this.getQuestionByQuestionId(questionId);
        const question = questionMetadata ? questionMetadata.question : undefined;
        const responses = this.getQuestionResponses(question);
        return responses;
    }

    autoCalculateVertical(props: any) {
        const autoCalConfig = props.question.auto_calculation_config;

        if (autoCalConfig.vertical_config) {
            const verticalConfig = autoCalConfig.vertical_config;
            if (verticalConfig.set_wise_questions) {
                const setwiseQuestions = verticalConfig.set_wise_questions;              
                if (verticalConfig && !autoCalConfig.is_horizontal) {
                    for (let setNo = 1; props.question.class_type >= setNo; setNo++) {                      
                        if (verticalConfig.operator && setwiseQuestions &&
                            setwiseQuestions.length === props.question.class_type &&
                            setwiseQuestions[setNo - 1] && setwiseQuestions[setNo - 1].question_ids.length > 0) {
                            
                            let calculatedValue: any = 0;
                            const questionIds = setwiseQuestions[setNo - 1].question_ids;
                            switch (verticalConfig.operator) {
                                case "+":
                                    {
                                      
                                        for (let questionIndex = 0; questionIds.length > questionIndex; questionIndex++) {
                                            const questionId = questionIds[questionIndex];
                                            const responses: any = this.getQuestionResponsesById(questionId);
                                           
                                            if (responses && responses[setNo - 1]) {
                                             
                                                if (isNaN(parseInt(responses[setNo - 1], 10))) {
                                                    calculatedValue += 0;
                                                 
                                                }
                                                else {
                                                    calculatedValue += parseInt(responses[setNo - 1], 10);
                                                    
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case "-":
                                    {
                                        let value;
                                        for (let questionIndex = 0; questionIds.length > questionIndex; questionIndex++) {
                                            const questionId = questionIds[questionIndex];
                                            const responses: any = this.getQuestionResponsesById(questionId);
                                            if (responses && responses[setNo - 1]) {
                                                if (isNaN(parseInt(responses[setNo - 1], 10))) {
                                                    if (value === undefined || value === null) {
                                                        calculatedValue = 0;
                                                        value = calculatedValue;
                                                    }
                                                    else {
                                                        calculatedValue -= 0;
                                                    }
                                                }
                                                else {
                                                    if (value === undefined || value === null) {
                                                        calculatedValue = parseInt(responses[setNo - 1], 10);
                                                        value = calculatedValue;
                                                    }
                                                    else {
                                                        calculatedValue -= parseInt(responses[setNo - 1], 10);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case "%":
                                    {
                                        if (questionIds && questionIds.length === 2) {
                                            const questionOneResponses: any = this.getQuestionResponsesById(questionIds[0]);
                                            const questionTwoResponses: any = this.getQuestionResponsesById(questionIds[1]);
                                            if (questionOneResponses && questionTwoResponses && !isNaN(parseInt(questionOneResponses[setNo - 1], 10)) && !isNaN(parseInt(questionTwoResponses[setNo - 1], 10))) {
                                                const unroundedValue = (parseInt(questionOneResponses[setNo - 1], 10) / parseInt(questionTwoResponses[setNo - 1], 10)) * 100;
                                                if (!Number.isNaN(unroundedValue)) {
                                                    const rounded = Math.round(unroundedValue * 10) / 10;
                                                    calculatedValue = rounded.toFixed(1);
                                                }
                                                else {
                                                    calculatedValue = 0;
                                                }
                                            }
                                            else {
                                                calculatedValue = 0
                                            }
                                        }

                                    }
                                    break;
                                case "%of":
                                    {
                                        if (questionIds && questionIds.length === 2) {
                                            const questionOneResponses: any = this.getQuestionResponsesById(questionIds[0]);
                                            const questionTwoResponses: any = this.getQuestionResponsesById(questionIds[1]);
                                            if (questionOneResponses && questionTwoResponses && !isNaN(parseInt(questionOneResponses[setNo - 1], 10)) && !isNaN(parseInt(questionTwoResponses[setNo - 1], 10))) {
                                                const unroundedValue = (parseInt(questionOneResponses[setNo - 1], 10) / 100) * parseInt(questionTwoResponses[setNo - 1], 10);
                                                if (!Number.isNaN(unroundedValue)) {
                                                    const rounded = Math.round(unroundedValue * 10) / 10;
                                                    calculatedValue = rounded.toFixed(1);
                                                }
                                                else {
                                                    calculatedValue = 0;
                                                }
                                            }
                                            else {
                                                calculatedValue = 0
                                            }
                                        }
                                    }
                                    break;
                            }

                            if (!Number.isNaN(calculatedValue)
                                && props.question
                                && props.question.question_responses
                                && props.question.question_responses[setNo - 1]
                                && props.question.question_responses[setNo - 1].value !== calculatedValue) {
                                updateQuestionDataValue(props, setNo, calculatedValue.toString(), false, null, true, [])
                              
                            }
                        }
                    }
                }
            }
        }
    }

    renderQuestion() {
        const elements: any = [];
        if (this.props && this.props.question.class_type !== undefined) {
            const isRedBlueApplicable = this.props.question.class_type === 2 && this.props.moduleId === ModuleEnum.VitaminAForecast ? true : false;

            for (let setNo: number = 1; setNo <= 3; setNo++) {
                let formClass = '';
                let labelClass = '';
                if (isRedBlueApplicable) {
                    formClass = setNo === 1 ? 'blueInput' : 'redInput';
                    labelClass = setNo === 1 ? 'blueInputLabel' : 'redInputLabel';
                }
                elements.push(<Grid key={this.props.pageNumber + '_label_' + this.props.questionId + "_" + setNo} item={true} sm={4} className="pb-0">
                    <FormControl margin="normal" fullWidth={true} className={formClass}>
                        <label className={labelClass}>
                            {
                                setNo === 1 ?
                                    (this.props.question.question_one_title ? this.props.question.question_one_title.en : '') :
                                    setNo === 2 ?
                                        (this.props.question.question_two_title ? this.props.question.question_two_title.en : '')
                                        :
                                        (this.props.question.question_three_title ? this.props.question.question_three_title.en : '')
                            }
                        </label>
                    </FormControl>
                </Grid>
                )
            }

            for (let setNo: number = 1; setNo <= this.props.question.class_type; setNo++) {
                if (this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + setNo] !== undefined) {
                    const autoCalConfig = this.props.question.auto_calculation_config;
                    let isHorizontalAutocalculation = false;
                    let isVerticalAutocalculation = false;
                    const isDisabled = this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + setNo + "isDisabled"];
                    if (autoCalConfig) {
                        if (autoCalConfig.is_horizontal && autoCalConfig.horizontal_config && setNo === 3) {
                            isHorizontalAutocalculation = true;
                        }

                        if (!autoCalConfig.is_horizontal && autoCalConfig.vertical_config
                            && autoCalConfig.vertical_config.set_wise_questions[setNo - 1].question_ids
                            && autoCalConfig.vertical_config.set_wise_questions[setNo - 1].question_ids.length > 0) {
                            isVerticalAutocalculation = true;
                        }
                    }

                    let formClass = '';
                    let controlClass = '';
                    if (isRedBlueApplicable) {
                        formClass = setNo === 1 ? 'blueInput' : 'redInput';
                        controlClass = setNo === 1 ? 'blueInputControl' : 'redInputControl';
                    }

                    elements.push(<Grid key={this.props.pageNumber + '_' + this.props.questionId + "_" + setNo} item={true} sm={4} className="pt-0">
                        <FormControl margin="normal" fullWidth={true} className={formClass + "mt-0"}>
                            <TextField
                                margin="normal"
                                variant="outlined"
                                type="number"
                                name={this.props.pageNumber + '_' + this.props.questionId + "_" + setNo}
                                value={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + setNo]}
                                disabled={isHorizontalAutocalculation || isVerticalAutocalculation || isDisabled || this.props.surveyStatus === SurveyStatusEnum.Finished}
                                autoFocus={false}
                                onChange={this.onAnswerChange.bind(this, setNo)}
                                onBlur={this.onAnswerBlur.bind(this, setNo)}
                                className={isHorizontalAutocalculation || isVerticalAutocalculation || isDisabled || this.props.surveyStatus === SurveyStatusEnum.Finished ? "disabledField" : (isRedBlueApplicable ? controlClass : '')}
                                onKeyPress={this.handleKeyPress.bind(this, setNo)}
                            />

                            <div className="autoOperatorSign">
                                {
                                    isHorizontalAutocalculation ?
                                        (autoCalConfig.horizontal_config.operator === '%' ? '%' : '')
                                        :
                                        ''
                                }

                                {
                                    isVerticalAutocalculation ?
                                        (autoCalConfig.vertical_config.operator === '%' ? '%' : '')
                                        :
                                        ''
                                }
                            </div>


                            {this.props.question.show_unavailable_checkbox &&
                                <FormControlLabel key={this.props.pageNumber + '_' + this.props.questionId + "_" + setNo + "_" + "Unavailable"}
                                    control={
                                        <Checkbox
                                            disabled={this.props.surveyStatus === SurveyStatusEnum.Finished}
                                            key={this.props.pageNumber + '_' + this.props.questionId + "_" + setNo + "_" + "Unavailable"}
                                            name={this.props.pageNumber + '_' + this.props.questionId + "_" + setNo + "_" + "Unavailable"}
                                            checked={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + setNo + "_" + "Unavailable"]}
                                            onChange={this.onUncheckedChange.bind(this, setNo, this.props.questionId + "_" + setNo)}
                                            value={"Unavailable"}
                                            color="primary"
                                        />
                                    }
                                    label="Unavailable"
                                />
                            }
                        </FormControl>
                    </Grid>);
                }
            }
        }
        return elements;
    }

    render() {
        return (
            <>
                {
                    this.renderQuestion()
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/responses/QuestionTypes/NumericTypeQuestionComponent.tsx